import HttpRequest from "@api/httpRequest";
import {RequestData} from "@models/axios";
import getPropByString from "@utils/get";
import {WidgetType} from "../models/widget";

const getUrl = (): string => {
    return `/widgets`;
};

function api() {
    return {
        getList: (data: RequestData) => {
            const {params = {}} = data;
            return HttpRequest.get(getUrl(), {
                params: params
            });
        },

        delete: (data: RequestData) => {
            const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
            return HttpRequest.delete(url, {});
        },

        getItem: (data: RequestData, type: WidgetType) => {
            const {params = {}} = data;
            const url = `${getUrl()}/${type}/${params.id}`
            return HttpRequest.get(url);
        },

        create: (data: RequestData, type: WidgetType) => {
            return HttpRequest.post(`${getUrl()}/${type}`, data.payload, {});
        },

        update: (data: RequestData, type: WidgetType) => {
            return HttpRequest.put(
                `${getUrl()}/${type}/${getPropByString(data, "params.id")}`,
                data.payload,
                {}
            );
        },
        updateOrder: (data: RequestData, type: WidgetType) => {
            return HttpRequest.post(`${getUrl()}/order/`, data.payload, {});
        }
    };
}

export default api();
